import { CommitteeManagementPageContent } from ".";

export default function InactiveCommitteesPage() {
  return <CommitteeManagementPageContent activeTab="inactive" />;
}
